<script>
    import Fa from 'svelte-fa';
    import { faClose } from '@fortawesome/pro-regular-svg-icons';
    import { fade, fly } from 'svelte/transition';

    import { browser } from '$app/environment';
    import { onMount } from 'svelte';

    export let modalOpen;
    export let name;

    // history state for draw open/closed history.back();
    $: if (modalOpen) {
        if (browser) {
            history.pushState({ [name]: true }, '', '');
            addEventListener('popstate', () => {}); // TODO: Move to layout hydration probably dont need to have multi listeners
            onpopstate = () => {
                if (modalOpen) {
                    modalOpen = false;
                }
            };
        }
    }

    // Only show modal after hydration
    let hydrated = false;
    onMount(() => {
        hydrated = true;
    });
</script>

{#if modalOpen && hydrated}
    <div class="fixed inset-0 z-40 flex w-full items-end justify-center lg:items-center" transition:fade={{ delay: 0, duration: 150 }}>
        <button
            class="absolute left-0 top-0 z-40 flex h-screen w-full bg-black/40 backdrop-blur-sm dark:bg-black/70 lg:inset-0 lg:items-center lg:justify-center"
            transition:fade={{ delay: 0, duration: 150 }}
            on:click={() => {
                history.back();
                modalOpen = !modalOpen;
            }}
        />
        <div
            class="no-scrollbar relative z-50 max-h-[90vh] w-full overflow-scroll rounded-t-md bg-base-900 px-6 py-10 text-left shadow-xl lg:max-w-2xl lg:rounded-2xl"
            transition:fly={{ y: 150, delay: 150 }}
        >
            <button
                class="absolute right-0 top-0 z-40 p-6"
                on:click={() => {
                    history.back();
                    modalOpen = !modalOpen;
                }}
            >
                <Fa icon={faClose} size="1.4x" />
            </button>
            <slot />
        </div>
    </div>
{/if}

<svelte:head>
    {#if modalOpen}
        <style>
            body {
                overflow: hidden !important;
            }
        </style>
    {/if}
</svelte:head>
